<div class="row">
    <div class="col-sm-6">
        <div id="job-applicant-filter-all-container" class="custom-checkbox" title="Search All filters">
            <label id="job-applicant-filter-all-label" class="checkbox-label font-normal">
                <input id="job-applicant-filter-all-checkbox" type="checkbox" [(ngModel)]="all" (change)="jobApplicantStatusFilter($event,'all')" />
                <span class="checkmark" style="top: -5px"></span>
                <p class="label-ppp"> All</p>
            </label>
        </div>
    </div>

    <div id="job-applicant-filter-list-container" *ngIf="jobApplicantStatusList.length > 0">
      <form id="job-applicant-filter-form" [formGroup]="jobApplicantFilterForm">
          <div *ngFor="let item of jobApplicantStatusList; let i = index">
              <div class="col-sm-6">
                  <div id="job-applicant-filter-item-{{i}}" class="custom-checkbox" title="Search {{item.value | titlecase}} filters">
                      <label id="job-applicant-filter-label-{{item.itemId}}" class="checkbox-label font-normal">
                          <input id="job-applicant-filter-checkbox-{{item.itemId}}" type="checkbox" formControlName="{{item.itemId}}"
                              (change)="jobApplicantStatusFilter($event , item.itemId)" />
                          <span class="checkmark" style="top: -5px"></span>
                          <p class="label-ppp"> {{item.value | titlecase}}</p>
                      </label>
                  </div>
              </div>
          </div>
      </form>
    </div>
</div>
